import styled, { keyframes } from 'styled-components';

const animation = keyframes`
  0%, 100% {
    background-position: 0 50%;
  }

  50% {
    background-position: 100% 50%;
  }
`;

/** @visibleName Loading Block */
const LoadingBlock = styled.div`
  height: 10px;
  width: ${props => props.width}%;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.2)
  );
  background-size: 600% 600%;
  animation: ${animation} 3s ease infinite;
`;

LoadingBlock.propTypes = {
  width: (props, propName, componentName) => {
    const width = props[propName];

    if (width < 1 || width > 100) {
      return new Error('Invalid range. Enter a value between from 1 to 100.');
    }

    return null;
  },
};

LoadingBlock.defaultProps = {
  width: 100,
};

/** @component */
export default LoadingBlock;
